export default __webpack_public_path__ + "static/media/wildfangz-open.842bc7d8.png";